module.exports = __webpack_public_path__ + "static/img/machine.c84f7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/machine.png
// module id = 231
// module chunks = 1